export default "__VITE_ASSET__c9b4f1e3__"